module.exports = __webpack_public_path__ + "img/54.9ed5c58e.jpg";